import { getPrivacyData } from '@/actions/legalPlages'
import { focusIds } from '@/constants/focus'
import { settingsTitles } from '@/constants/settings'

import { StaticHTMLPage } from './StaticHTMLPage'

const focusId = `${focusIds.SETTINGS_DATA_PRIVACY}${focusIds.CONTAINER_MOD}`

export const DataPrivacy = () => (
  <StaticHTMLPage
    titleTranslationKey={settingsTitles.DATA_PRIVACY}
    onPageLoad={getPrivacyData}
    focusId={focusId}
  />
)
